






























































import Component, { mixins } from 'vue-class-component'
import confirmMixin from '@/modules/common/mixins/confirmMixin'
import loading from '@/modules/common/components/loading.vue'
import notificationService from '@/modules/common/services/notificationService'
import page from '@/modules/common/components/page.vue'
import Pass from '@/modules/pass/domain/pass'
import passService from '@/modules/pass/domain/passService'
import passDetail from '@/modules/pass/components/passDetail.vue'
import submitProtectionMixin from '@/modules/common/mixins/submitProtectionMixin'

@Component({
  components: { loading, page, passDetail }
})
export default class DetailPage extends mixins(confirmMixin, submitProtectionMixin) {
  pass: Pass | null = null
  edit = false

  get title () {
    return this.pass ? this.pass.name : ''
  }

  publish () {
    this.confirm('pass.publish.confirmation').then(async (value: boolean) => {
      if (value) {
        await passService.publish(this.pass!)
        notificationService.success('pass.publish.success')
      }
    })
  }

  async created () {
    this.pass = await passService.getPass()
  }
}
